export const ignore = 'IGNORE'
export const inherit = 'INHERIT'
export const recursive = 'RECURSIVE'
export const as_single = 'AS_SINGLE'
